import { LoadingStiModule } from './../../../../_component/loading-sti/loading-sti.module';
import { ApiNotFoundComponentModule } from './../../../_component/api-not-found/api-not-found.component.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CommentModule } from 'src/app/app/_component/comment/comment.module';
import { SelectButtonsModule } from 'src/app/app/_component/select-buttons/select-buttons.module';
import { CardComponentModule } from 'src/app/app/_component/_structural/card/card.module';
import { HeaderModule } from 'src/app/_component/header/header.module';
import { UserWithAvatarModule } from '../../../_component/user-with-avatar/user-with-avatar.module';
import { ReportModule } from '../../report/report.module';
import { BreadcrumbComponentModule } from './../../../_component/breadcrumb/breadcrumb.module';
import { EditReportTaskPageRoutingModule } from './edit-report-task-routing.module';
import { EditReportTaskPage } from './edit-report-task.page';
import { ReportTaskDetailComponentModule } from '../report-task-detail/report-task-detail.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    EditReportTaskPageRoutingModule,
    ReportModule,
    TranslateModule,
    CommentModule,
    HeaderModule,
    SelectButtonsModule,
    UserWithAvatarModule,
    CardComponentModule,
    BreadcrumbComponentModule,
    ApiNotFoundComponentModule,
    ReportTaskDetailComponentModule,
    LoadingStiModule,
  ],
  declarations: [EditReportTaskPage],
})
export class EditReportTaskPageModule {}
